var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('CLayoutTemplate',[_c('CDefaultApplication',{on:{"open-login-modal":_vm.openLoginPage,"open-signup-modal":_vm.openSignupPage}},[_c('nuxt')],1),_vm._v(" "),_c('CAvailableUptimeUpdateModal'),_vm._v(" "),_c('CInformationModal')],1)}
var staticRenderFns = []

export { render, staticRenderFns }